import { render, staticRenderFns } from "./PublicNews.vue?vue&type=template&id=015ebc88&scoped=true"
import script from "./PublicNews.vue?vue&type=script&lang=js"
export * from "./PublicNews.vue?vue&type=script&lang=js"
import style0 from "./PublicNews.vue?vue&type=style&index=0&id=015ebc88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ebc88",
  null
  
)

export default component.exports